import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { HtlBlockNumber, HtlService } from "../../htl/htl.service";
import { ShortItem } from "../../shared/models/shortItem.model";
import { NextDueMaintenanceService } from "../next-due-maintenance.service";
// tslint:disable-next-line:max-line-length
import { UpdateNextDueMaintenanceDialogComponent } from "../update-next-due-maintenance-dialog/update-next-due-maintenance-dialog.component";
import { NextDueMaintenanceDeleteDialogComponent } from "../next-due-maintenance-delete-dialog/next-due-maintenance-delete-dialog.component";
import { LocalStorageService } from "../../shared/local-storage.service";
import { forkJoin, Observable } from "rxjs";
import { ExcelExportComponent, ExcelExportData } from "@progress/kendo-angular-excel-export";
import { Helicopter } from "../../shared/models/helicopter.model";
import { FilterDescriptor, process, State } from "@progress/kendo-data-query";
import { DataStateChangeEvent, ExcelExportEvent, GridDataResult, GridComponent, FieldAccessorPipe } from "@progress/kendo-angular-grid";
import { AppConfigType } from "../../shared/models/appConfig.model";
import { HHMM } from "@rrsolutionsit/atl-utils";
import moment from "moment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-next-due-maintenance-table",
    templateUrl: "./next-due-maintenance-table.component.html",
    styleUrls: ["./next-due-maintenance-table.component.scss"],
    standalone: false,
})
export class NextDueMaintenanceTableComponent implements OnInit, OnChanges {
    @Input({ required: true }) aircraft: Helicopter;
    @Input({ required: true }) helicopterData: any;
    @Input({ required: true }) helicopterWarnings: any;
    @Input() helicopterHooks: any;
    @Input() helicopterHoists: any;

    public displayedColumns: string[] = [
        "position",
        "description",
        "intervalHours",
        "nextDueHours",
        "intervalDays",
        "nextDueDate",
        "intervalFlightNumber",
        "nextDueFlightNumber",
        "accomplishent",
        "cs",
        "actions",
    ];
    public htlBlockNumberArray: HtlBlockNumber[] = [];
    public htlBlockNumber: number = -1;

    private _helicopterId: number;
    public selectedStlId: number;

    public isCamo = false;
    private _userSession;

    public gridColumns = [];

    public itemSelected = false;
    public canDelete = false;

    public showTolerance = false;
    public showFlightNumber = false;
    public showReference = false;
    public startBlockNumber = 0;

    public gridView: GridDataResult;
    public data: any[] = [];

    public pageSizes = [25, 50, 100, 200];

    public filename: string;

    public state: State = {
        skip: 0,
        take: this.pageSizes[0],
    };

    public totalHours: string = "00:00";
    public totalCycles: number = 0;

    public showOpenItems = true;
    public showEnginePowerCheck = false;

    public hookHoistActive = false;
    public showHookHoist = false;
    public showDays = false;

    @Output() dataLoaded = new EventEmitter();
    @Output() tabChanged = new EventEmitter<number>();

    constructor(
        private _route: ActivatedRoute,
        private _dialog: MatDialog,
        private _nextDueMaintenanceService: NextDueMaintenanceService,
        private _localStorageService: LocalStorageService,
        private _htlService: HtlService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
    }

    ngOnInit(): void {
        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).tolerance) {
            this.showTolerance = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).reference) {
            this.showReference = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.flightNumber).enabled)) {
            this.showFlightNumber = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.enginePowerCheck).value).automatic) {
            this.showEnginePowerCheck = true;
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.nightInspectionHoist).enabled)) {
            this.showDays = true;
        }

        this.activateHookHoist();

        this.setGridColumns();

        if (this._userSession.htlAccountTypes.length > 0) {
            switch (this._userSession.htlAccountTypes[0].id) {
                case 1:
                    this.isCamo = true;
                    break;
                case 2:
                    this.isCamo = true;
                    break;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["helicopterData"] && changes["helicopterData"].currentValue) {
            this._htlService.getHtlBlockNumbersByHelicopterId(this.aircraft.id).subscribe((result) => {
                this.htlBlockNumberArray = result.reverse();
                this.htlBlockNumber = result[0].id;
                this.startBlockNumber = this.htlBlockNumber;
                this.canDelete = false;
                this.showOpenItems = true;
                this.state.take = this.pageSizes[0];
                this._helicopterId = this.aircraft.id;
                this.filename = "NextDueMaintenances_" + this.aircraft.registrationMark.trim();
                this.totalHours = HHMM.sumTimes(this.helicopterData?.totalHours, this.helicopterData?.flightSUM).value;
                this.totalCycles = this.helicopterData?.totalCycles + this.helicopterData?.currentCycles;
                if (this.helicopterHooks.length <= 0 && this.helicopterHoists.length <= 0) {
                    this.hookHoistActive = false;
                    this.showHookHoist = false;
                } else {
                    this.activateHookHoist();
                }
                if (this.showHookHoist) {
                    this.fetchHookHoistData();
                } else {
                    this.fetchShortTermData();
                }
            });
        }
    }

    activateHookHoist() {
        if (
            JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.hooks).value).inspections ||
            JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.hoist).value).inspections
        ) {
            this.hookHoistActive = true;
        }
    }

    onHtlBlockNumberChange(event: MatSelectChange) {
        this.htlBlockNumber = event.value;
        if (!this.showHookHoist) {
            this.fetchShortTermData();
        }
    }

    public fetchShortTermData() {
        console.log("FETCHING SHORT TERM DATA WITH BLOCK: ", this.htlBlockNumber);
        console.log("BLOCKARR", this.htlBlockNumberArray);
        /*
    this.htlBlockNumberArray.forEach(b => {
      console.log("BLOCK:", b.id);
    })
    if (this.htlBlockNumber !== this.htlBlockNumberArray[this.htlBlockNumberArray.length - 1].id) {
      this.showOpenItems = false;
    }
      */
        this.state.skip = 0;
        this.data = [];
        this._nextDueMaintenanceService.getShortThermsByBlockId(this.htlBlockNumber).subscribe({
            next: (resultArray) => {
                console.log("SHORT TERM DATA LOADED (BLOCK: " + this.htlBlockNumber + ")");
                resultArray.forEach((item) => {
                    this.data.push(this.populateItemData(item));
                });
                this.populateGrid();
            },
            error: (error) => console.log("Error on fetch short term items", error),
        });
    }

    public fetchHookHoistData() {
        console.log("FETCH HOOK HOIST");
        this.state.skip = 0;
        this.data = [];
        this._nextDueMaintenanceService.getAccessories(this._helicopterId).subscribe((result) => {
            console.log("HOOK HOIST DATA LOADED");
            result.forEach((item) => {
                this.data.push(this.populateItemData(item));
            });
            this.populateGrid();
        });
    }

    public populateGrid() {
        let showData = this.data || [];
        if (this.showOpenItems) {
            showData = this.data.filter((d) => d.signature === undefined || d.signature === null);
        }
        this.dataLoaded.emit(showData);
        this.gridView = process(showData, this.state);
        console.log("GRID POPULATED");
    }

    populateItemData(item) {
        console.log("populate item data");
        const hours =
            item.hookId && item.hookId !== null ? this.helicopterHooks[0]?.hours : item.hoistId && item.hoistId !== null ? this.helicopterHoists[0]?.hours : this.totalHours;
        const cycles =
            item.hookId && item.hookId !== null ? this.helicopterHooks[0]?.cycles : item.hoistId && item.hoistId !== null ? this.helicopterHoists[0]?.cycles : this.totalCycles;
        if (item.maintenanceAccountName && item.maintenanceAccountName !== null) {
            item.signature = item.maintenanceAccountName;
        } else if (item.pilotName && item.pilotName !== null) {
            item.signature = item.pilotName;
        }
        if (item.nextDueHours && (item.signature === null || item.signature === undefined)) {
            item.remainingHours = HHMM.subtractTimes(item.nextDueHours, hours).value;
            if (
                item.remainingHours &&
                HHMM.subtractTimes(item.remainingHours, "00:01").value.indexOf("-") >= 0 &&
                HHMM.sumTimes(item.remainingHours, item.toleranceHours).value.indexOf("-") === -1 &&
                item.toleranceHours !== HHMM.zero().value
            ) {
                item.remainingHours = HHMM.sumTimes(item.remainingHours, item.toleranceHours).value;
                item.hoursTolerance = true;
            }
        }
        if (item.nextDueDate && (item.signature === null || item.signature === undefined)) {
            item.remainingDays = Math.floor((new Date(item.nextDueDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) + 1;
            if (item.remainingDays <= 0 && item.remainingDays + item.toleranceDays > 0 && item.toleranceDays > 0) {
                item.remainingDays = item.remainingDays + item.toleranceDays;
                item.daysTolerance = true;
            }
        }
        if (item.nextDueFlightNumber && (item.signature === null || item.signature === undefined)) {
            item.remainingFlightNumber = parseInt(item.nextDueFlightNumber) - this.helicopterData.flightNumber;
            if (item.remainingFlightNumber <= 0 && item.remainingFlightNumber + item.toleranceFlightNumber > 0 && item.toleranceFlightNumber > 0) {
                item.remainingFlightNumber = item.remainingFlightNumber + item.toleranceFlightNumber;
                item.flightNumberTolerance = true;
            }
        }
        if (item.nextDueCycles && (item.signature === null || item.signature === undefined)) {
            item.remainingCycles = item.nextDueCycles - cycles;
            if (item.remainingCycles <= 0 && item.remainingCycles + item.toleranceCycles > 0 && item.toleranceCycles > 0) {
                item.remainingCycles = item.remainingCycles + item.toleranceCycles;
                item.cyclesTolerance = true;
            }
        }
        if (item.nextDueDate) {
            item.nextDueDateText = moment(new Date(item.nextDueDate)).format("DD-MM-yyyy");
        }
        if (item.status) {
            item.statusText = item.signature ? "Performed" : item.status === 1 ? this._translate.instant("HTL.SHORTITEM.active") : this._translate.instant("HTL.SHORTITEM.stopped");
        }
        if (item.performedDate) {
            item.performedDateText = moment(new Date(item.closureDate)).format("DD-MM-yyyy");
        }
        if (item.createdAt) {
            item.createdAtText = moment(new Date(item.createdAt)).format("DD-MM-yyyy");
        }
        if (item.performedHours && item.performedHours.length - item.performedHours.indexOf(":") === 2) {
            item.performedHours =
                item.performedHours.substring(0, item.performedHours.indexOf(":") + 1) + "0" + item.performedHours.substring(item.performedHours.indexOf(":") + 1);
        }
        switch (item.type) {
            case 0:
                item.typeText = "Single Task";
                break;
            case 1:
                item.typeText = "Recurring";
                break;
            case 2:
                item.typeText = "Recurring Closed";
                break;
        }
        if (item.hookId !== null) {
            item.serial = this.helicopterHooks[0]?.serial;
        }
        if (item.hoistId !== null) {
            item.serial = this.helicopterHoists[0]?.serial;
        }
        if (item.mode) {
            item.mode = item.mode === 2;
        }
        return item;
    }

    openUpdateShortItemDialog() {
        const shortItem = this.data.find((s) => s.id === this.selectedStlId);
        const dialogRef = this._dialog.open(UpdateNextDueMaintenanceDialogComponent, {
            disableClose: true,
            width: "50%",
            data: {
                helicopterId: this._helicopterId,
                shortItem: shortItem,
                showTolerance: this.showTolerance,
                showFlightNumber: this.showFlightNumber,
                registrationMark: this.aircraft.registrationMark,
                disableEnginePowerCheck: true,
                showReference: this.showReference,
                showEnginePowerCheck: this.showEnginePowerCheck,
                hookHoist: this.showHookHoist,
                helicopterData: this.helicopterData,
                hooks: this.helicopterHooks,
                hoists: this.helicopterHoists,
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (this.showHookHoist) {
                this.fetchHookHoistData();
            } else {
                this.fetchShortTermData();
            }
            this.selectedStlId = null;
            this.itemSelected = false;
            this.canDelete = false;
        });
    }

    openDeleteShortItemDialog() {
        const dialogRef = this._dialog.open(NextDueMaintenanceDeleteDialogComponent, {
            disableClose: true,
            width: "20%",
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (this.showHookHoist) {
                    this._nextDueMaintenanceService.deleteAccessory(this.selectedStlId).subscribe({
                        next: () => {
                            this.fetchHookHoistData();
                            this.selectedStlId = null;
                            this._snackBar.open(this._translate.instant("GENERAL.deleteSuccessMsg"), this._translate.instant("GENERAL.close"), {
                                duration: 3000,
                            });
                        },
                        error: (e) => {
                            this._snackBar.open(this._translate.instant("GENERAL.errorMsg"), this._translate.instant("GENERAL.close"), {
                                duration: 3000,
                            });
                        },
                    });
                } else {
                    this._nextDueMaintenanceService.deleteShortItem(this.selectedStlId).subscribe({
                        next: () => {
                            this.fetchShortTermData();
                            this.selectedStlId = null;
                            this._snackBar.open(this._translate.instant("GENERAL.deleteSuccessMsg"), this._translate.instant("GENERAL.close"), {
                                duration: 3000,
                            });
                        },
                        error: (e) => {
                            this._snackBar.open(this._translate.instant("GENERAL.errorMsg"), this._translate.instant("GENERAL.close"), {
                                duration: 3000,
                            });
                        },
                    });
                }
            }
        });
    }

    public onSelectionChange(event) {
        this.itemSelected = false;
        this.canDelete = false;
        if (event.selectedRows.length >= 1) {
            this.selectedStlId = event.selectedRows[0].dataItem.id;
            this.itemSelected = true;
            if (!event.selectedRows[0].dataItem.signature) {
                this.canDelete = true;
            } else {
                this.canDelete = false;
            }
        }
    }

    public excelExportData(e: ExcelExportEvent) {
        const rows = e.workbook.sheets[0].rows;

        // set alternating row color
        let altIdx = 0;
        rows.forEach((row) => {
            if (row.type === "data") {
                if (altIdx % 2 !== 0) row.cells.forEach((cell) => (cell.background = "#f2f7ff"));
                altIdx++;
            }
        });
    }

    dataStateChange(state: DataStateChangeEvent) {
        this.state = state;
        this.gridView = process(this.data, this.state);
    }

    getStyles(dataItem, field) {
        if (!dataItem) {
            return {};
        }
        switch (field) {
            case "remainingHours":
                if (dataItem.remainingHours && HHMM.subtractTimes(dataItem.remainingHours, "00:01").value.indexOf("-") >= 0) {
                    return { "background-color": "red" };
                }
                if (dataItem.hoursTolerance && dataItem.remainingHours) {
                    return { "background-color": "orange" };
                }
                const warningHours =
                    this.helicopterWarnings?.hours !== null
                        ? this.helicopterWarnings?.hours
                        : JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).hours;
                if (dataItem.remainingHours && HHMM.subtractTimes(dataItem.remainingHours, warningHours).value.indexOf("-") >= 0) {
                    return { "background-color": "yellow" };
                }
                break;
            case "remainingDays":
                if (dataItem.remainingDays <= 0) {
                    return { "background-color": "red" };
                }
                if (dataItem.daysTolerance && dataItem.remainingDays) {
                    return { "background-color": "orange" };
                }
                const warningDays =
                    this.helicopterWarnings?.days !== null
                        ? this.helicopterWarnings?.days
                        : JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).days;
                if (dataItem.remainingDays - warningDays <= 0) {
                    return { "background-color": "yellow" };
                }
                break;
            case "remainingFlightNumber":
                if (dataItem.remainingFlightNumber <= 0) {
                    return { "background-color": "red" };
                }
                if (dataItem.flightNumberTolerance && dataItem.remainingFlightNumber) {
                    return { "background-color": "orange" };
                }
                const warningFlightNumber =
                    this.helicopterWarnings?.flightNumbers !== null
                        ? this.helicopterWarnings?.flightNumbers
                        : JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).flightNumber;
                if (dataItem.remainingFlightNumber - warningFlightNumber <= 0) {
                    return { "background-color": "yellow" };
                }
                break;
            case "remainingCycles":
                if (dataItem.remainingCycles <= 0) {
                    return { "background-color": "red" };
                }
                if (dataItem.cyclesTolerance && dataItem.remainingCycles) {
                    return { "background-color": "orange" };
                }
                const warningCycles =
                    this.helicopterWarnings?.cycles !== null
                        ? this.helicopterWarnings?.cycles
                        : JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.shortFrequencyWarnings).value).cycles;
                if (dataItem.remainingCycles - warningCycles <= 0) {
                    return { "background-color": "yellow" };
                }
                break;
        }
        return {};
    }

    public applyOpenItemsFilter() {
        if (this.showOpenItems) {
            this.state.skip = 0;
        }
        this.populateGrid();
    }

    public onTabChange(index: number) {
        this.tabChanged.emit(index);
        this.showHookHoist = index === 1;
        this.setGridColumns();
        this.state.skip = 0;
        this.canDelete = false;
        if (index === 0) {
            this.fetchShortTermData();
        } else {
            this.fetchHookHoistData();
        }
    }

    public setGridColumns() {
        this.gridColumns = [
            {
                field: "inspectionTypeName",
                title: "Description",
                width: "200px",
                isGroup: false,
            },
            { field: "serial", title: "Serial", width: "100px", isGroup: false, disabled: !this.showHookHoist },
            { field: "statusText", title: "Status", width: "100px", isGroup: false },
            { field: "typeText", title: "Type", width: "100px", isGroup: false },
            { field: "reference", title: "Ref.", width: "100px", isGroup: false, disabled: !this.showReference },
            { field: "isEnginePowerCheck", title: "EPC", width: "80px", isGroup: false, disabled: !this.showEnginePowerCheck || this.showHookHoist, isBool: true },
            {
                field: "interval",
                title: "Interval",
                isGroup: true,
                cols: [
                    { field: "intervalHours", title: "Hours", width: "100px" },
                    { field: "intervalDays", title: "Days", width: "100px", disabled: this.showHookHoist && !this.showDays },
                    {
                        field: "intervalFlightNumber",
                        title: "FN",
                        width: "100px",
                        disabled: !this.showFlightNumber || this.showHookHoist,
                    },
                    { field: "intervalCycles", title: "Cycles", width: "100px" },
                ],
            },
            {
                field: "nextDue",
                title: "Next due",
                isGroup: true,
                cols: [
                    { field: "nextDueHours", title: "Hours", width: "100px" },
                    { field: "nextDueDateText", title: "Date", width: "110px", disabled: this.showHookHoist && !this.showDays },
                    {
                        field: "nextDueFlightNumber",
                        title: "FN",
                        width: "100px",
                        disabled: !this.showFlightNumber || this.showHookHoist,
                    },
                    { field: "nextDueCycles", title: "Cycles", width: "100px" },
                ],
            },
            {
                field: "remaining",
                title: "Remaining",
                isGroup: true,
                cols: [
                    { field: "remainingHours", title: "Hours", width: "100px" },
                    { field: "remainingDays", title: "Days", width: "100px", disabled: this.showHookHoist && !this.showDays },
                    {
                        field: "remainingFlightNumber",
                        title: "FN",
                        width: "100px",
                        disabled: !this.showFlightNumber || this.showHookHoist,
                    },
                    { field: "remainingCycles", title: "Cycles", width: "100px" },
                ],
            },
            {
                field: "tolerance",
                title: "Tolerance",
                isGroup: true,
                disabled: !this.showTolerance,
                cols: [
                    { field: "toleranceHours", title: "Hours", width: "100px" },
                    { field: "toleranceDays", title: "Days", width: "100px", disabled: this.showHookHoist && !this.showDays },
                    {
                        field: "toleranceFlightNumber",
                        title: "FN",
                        width: "100px",
                        disabled: !this.showFlightNumber || this.showHookHoist,
                    },
                    { field: "toleranceCycles", title: "Cycles", width: "100px" },
                ],
            },
            {
                field: "performed",
                title: "Performed at",
                isGroup: true,
                cols: [
                    { field: "performedHours", title: "Hours", width: "100px" },
                    { field: "performedDateText", title: "Date", width: "110px", disabled: this.showHookHoist && !this.showDays },
                    {
                        field: "performedFlightNumber",
                        title: "FN",
                        width: "100px",
                        disabled: !this.showFlightNumber || this.showHookHoist,
                    },
                    { field: "performedCycles", title: "Cycles", width: "100px" },
                ],
            },
            {
                field: "createdAtText",
                title: "Created",
                width: "110px",
                isGroup: false,
            },
            {
                field: "completedCRS",
                title: "Accomplishment CRS/ATL ref",
                width: "150px",
                isGroup: false,
                disabled: this.showHookHoist,
            },
            {
                field: "signature",
                title: "CS",
                width: "150px",
                isGroup: false,
            },
        ];
    }
}
